import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainPage from './features/home/MainPage';

// Lazy load components for better performance
const ThankYou = React.lazy(() => import('./features/booking/ThankYou'));
const BlogListPage = React.lazy(() => import('./features/blog/BlogListPage'));
const BlogPostPage = React.lazy(() => import('./features/blog/BlogPostPage'));
const ResourcesPage = React.lazy(() => import('./features/resources/ResourcesPage'));
const TallerDolorParto = React.lazy(() => import('./features/taller/TallerDolorParto'));

// Loading component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-contessa-500"></div>
  </div>
);

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route 
        path="/thank-you" 
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <ThankYou />
          </Suspense>
        } 
      />
      <Route 
        path="/blog" 
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <BlogListPage />
          </Suspense>
        } 
      />
      <Route 
        path="/blog/:slug" 
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <BlogPostPage />
          </Suspense>
        } 
      />
      <Route 
        path="/recursos" 
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <ResourcesPage />
          </Suspense>
        } 
      />
      <Route
        path="/taller-dolor-parto"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <TallerDolorParto />
          </Suspense>
        }
      />
    </Routes>
  );
}

export default App;